export default __webpack_public_path__ + "938af76f96cf85f9858e4ce266a1c6e8.png";